<div class="dashboard-skeleton flex flex-column gap-5" aria-busy="true" aria-label="Loading your dashboard">
  <!-- Top row: welcome banner + quick actions (left) and profile completion (right) -->
  <div class="sk-top-row">
    <div class="sk-left-column flex flex-column gap-4">
      <div class="sk-card sk-welcome">
        <p-skeleton width="40%" height="1.75rem" styleClass="mb-3"></p-skeleton>
        <p-skeleton width="70%" height="1rem" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="55%" height="1rem"></p-skeleton>
      </div>

      <div class="sk-card">
        <p-skeleton width="30%" height="1.25rem" styleClass="mb-3"></p-skeleton>
        <div class="sk-quick-grid">
          <div class="sk-quick-cell" *ngFor="let cell of quickActionCells">
            <p-skeleton shape="circle" size="3rem" styleClass="mb-2"></p-skeleton>
            <p-skeleton width="70%" height="0.75rem"></p-skeleton>
          </div>
        </div>
      </div>
    </div>

    <div class="sk-right-column">
      <div class="sk-card sk-profile-card flex flex-column align-items-center">
        <p-skeleton width="50%" height="1.25rem" styleClass="mb-3"></p-skeleton>
        <p-skeleton shape="circle" size="9rem" styleClass="mb-4"></p-skeleton>
        <div class="sk-checklist">
          <div class="sk-checklist-row flex align-items-center gap-2" *ngFor="let row of checklistRows">
            <p-skeleton shape="circle" size="1.5rem"></p-skeleton>
            <p-skeleton width="70%" height="0.9rem"></p-skeleton>
          </div>
        </div>
        <p-skeleton width="100%" height="2.5rem" styleClass="mt-3"></p-skeleton>
      </div>
    </div>
  </div>

  <!-- Wide block: milestones / applications area -->
  <div class="sk-card sk-wide">
    <div class="flex justify-content-between align-items-center mb-4">
      <p-skeleton width="30%" height="1.5rem"></p-skeleton>
      <p-skeleton width="12%" height="2.5rem"></p-skeleton>
    </div>
    <div class="sk-stat-row">
      <div class="sk-stat-box" *ngFor="let box of statBoxes">
        <p-skeleton shape="circle" size="2.5rem" styleClass="mb-2"></p-skeleton>
        <p-skeleton width="40%" height="1.25rem" styleClass="mb-1"></p-skeleton>
        <p-skeleton width="70%" height="0.75rem"></p-skeleton>
      </div>
    </div>
    <p-skeleton width="100%" height="10rem" styleClass="mt-4"></p-skeleton>
  </div>

  <!-- Promo cards -->
  <div class="sk-promo-row">
    <div class="sk-card sk-promo" *ngFor="let card of promoCards">
      <p-skeleton width="60%" height="1.25rem" styleClass="mb-3"></p-skeleton>
      <p-skeleton width="100%" height="6rem"></p-skeleton>
    </div>
  </div>
</div>
